// src/components/AreaChart.js
import React from 'react';
import { Line } from 'react-chartjs-2';
import { Chart as ChartJS, LineElement, CategoryScale, LinearScale, PointElement } from 'chart.js';

ChartJS.register(LineElement, CategoryScale, LinearScale, PointElement);

const AreaChart = ({ data, title, color,label }) => {
    console.log("leadtypedata",data);
  const chartData = {
    labels: data.months,
    datasets: [
      {
        label: title,
        data: data.values,
        backgroundColor: `rgba(${color[0]}, ${color[1]}, ${color[2]}, 0.1)`, // Adjust the transparency for the area color
        borderColor: `rgba(${color[0]}, ${color[1]}, ${color[2]}, 1)`,
        borderWidth: 2,
        pointRadius: 0, // Hide markers
        fill: true, // Fill the area under the line
      },
    ],
  };

  const chartOptions = {
    responsive: true,
    plugins: {
      legend: {
        display: false, // Hide legend
      },
      tooltip: {
        enabled: false, // Disable tooltips
      },
    },
    scales: {
      x: {
        display: false, // Hide x-axis
      },
      y: {
        display: false, // Hide y-axis
      },
    },
    elements: {
      line: {
        tension: 0.4, 
      },
    },
  };

  return (
    <div style={{ height: '100px', width: '100px' }}>
      <Line data={chartData} options={chartOptions} />
         {label && (
        <div style={{ textAlign: 'center', marginTop: '10px', fontSize: '12px' }}>
          {label}
        </div>
      )}
    </div>

 
  );
};

export default AreaChart;
